import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
    Container,
} from 'reactstrap';

import { PortalTextLogin } from '../../Models/Api/strongbox.financialportal';

import { ApplicationState } from '../../Store';
import {
    GetPortalLoginText,
} from '../../Store/PortalAssets';

import AppLogo from '../../images/applogo.svg';

type InjectedReduxState = {
    portalLoginText?: PortalTextLogin;
};

type InjectedActionCreators = {};

type AppTitleHeaderProps = {
    leftAlign?: boolean;
};

type Props = AppTitleHeaderProps & InjectedReduxState & InjectedActionCreators;

const AppTitleHeaderComponent: React.FC<Props> = (props): React.ReactElement => {
    const {
        portalLoginText,
        leftAlign,
    } = props;

    return (
        <Container 
            fluid 
            className={`login-content-elements ${ leftAlign === true ? ' login-content-elements-left' : ''}`}
        >
            <img 
                src={AppLogo} 
                alt={portalLoginText?.appTitle || ''}
            />
        </Container>
    );
}

export const AppTitleHeader = connect<InjectedReduxState, InjectedActionCreators, AppTitleHeaderProps, ApplicationState>(
    (appState: ApplicationState) => {
        const result: InjectedReduxState = {
            portalLoginText: GetPortalLoginText(appState),
        };

        return result;
    },
    dispatch => bindActionCreators(
        {
        },
        dispatch
    )
)(AppTitleHeaderComponent);
